export var MeasurementSystem;
(function (MeasurementSystem) {
    MeasurementSystem["Imperial"] = "imperial";
    MeasurementSystem["Metric"] = "metric";
})(MeasurementSystem || (MeasurementSystem = {}));
//# sourceMappingURL=user-preferences.js.map